import type { FC } from 'react'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { setCalendarId } from 'redux/actions'
import { AddCalendar } from 'pages/my-calendars/add-calendar'

export const EditPage: FC = () => {
    const dispatch = useDispatch()
    const { calendarId } = useParams<{
        calendarId: string
    }>()

    useEffect(() => {
        dispatch(setCalendarId(calendarId))
    }, [])

    return (
        <>
            <AddCalendar />
        </>
    )
}
